import type { FilterLayout } from '@/component/Table/types';
import type { AllTexts } from '@/feature/lang/types';
import type { Column } from '@tanstack/react-table';

export function getInputProps(
  column: Column<any> | undefined,
  layout: FilterLayout | undefined,
  texts: AllTexts
) {
  if (layout === 'popup') {
    return {
      label: column?.columnDef.meta?.name,
      size: 'medium' as const,
      margin: 'normal' as const,
    };
  } else {
    return {
      placeholder: texts.component.dataGrid.filter.placeholder,
      size: 'small' as const,
      margin: 'dense' as const,
    };
  }
}
